import { render } from "./MarketplaceSettingsModal.vue?vue&type=template&id=761e5e70&ts=true&lang=pug"
import script from "./MarketplaceSettingsModal.vue?vue&type=script&lang=ts"
export * from "./MarketplaceSettingsModal.vue?vue&type=script&lang=ts"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__